import { useEffect, useRef } from 'react';
import type { Point } from './toPortInfo.tsx';
import type { Positionable } from './ListEdgeDetails.tsx';
import type { DragDropState } from './useCanvasDragDropEvents.tsx';
import { getDraggingItem } from './getDraggingItem.tsx';

export interface Props {
	isImmutable: boolean;
	dragDropState: DragDropState;
	snappedSubjectPosition: Point | undefined;
	onItemMove?: (positionable: Positionable) => void;
}

export const useItemDragDrop = ({
	isImmutable,
	dragDropState,
	snappedSubjectPosition,
	onItemMove,
}: Props): {
	draggingItem: Positionable | undefined;
} => {
	const previousDraggingItem = useRef<Positionable | undefined>(undefined);

	const draggingItem = isImmutable
		? undefined
		: getDraggingItem(dragDropState, snappedSubjectPosition);

	useEffect(() => {
		if (!draggingItem && previousDraggingItem.current) {
			// item has been dropped
			// eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
			onItemMove?.(previousDraggingItem.current);
		}

		previousDraggingItem.current = draggingItem;
	}, [draggingItem, onItemMove]);

	return { draggingItem };
};
